/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import CTA from "../components/cta";

class ETSection2 extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-15-et block-3 z-16">
                    <div className="container relative-text p-40">
                        <div className="row m0 hide-on-med-and-down">
                            <div className="col s12 m5 left-align">
                                <img className="img-sticky responsive-img relative-text" src="../static/Mastermind-ET-3.png"/>
                            </div>
                            <div className="col s12 m7 left-align p0">
                                <h1 className="f-62 white-text bold-text text-uppercase mobile-center mb0 text-shadow-blue">Dr. Eric<br/><span className="f-100 ls-5 white-text">Thomas</span> </h1>
                                <p className="f-32 white-text bold-text left-align mobile-center m0">will be in the building!</p>
                                <p className="f-18 white-text mobile-center">Meet face-to-face with Eric Thomas, ET, The Hip Hop Preacher is bringing his motivation to Newark, NJ for the TAKE OWNERSHIP mastermind experience.</p>
                                <br/>
                                <p className="f-18 white-text mobile-center"><span className="f-26 bold-text">TAKE OWNERSHIP</span> is the end of the year mastermind event for people looking to make one new connection, learn one new strategy, and get leverage on themselves to exponentially grow their business.</p>
                                <div className="col s12 left-align mobile-center p0">
                                    <br/>
                                    <CTA/>
                                    <br/>
                                </div>
                            </div>
                        </div>
                        <div className="row m0 hide-on-large-only">
                            <div className="col s12 center-align p0">
                                <h1 className="f-62 white-text bold-text text-uppercase mobile-center mb0 text-shadow-blue">Dr. Eric<br/><span className="f-100 ls-5 white-text">Thomas</span> </h1>
                                <p className="f-32 white-text bold-text mobile-center m0">will be in the building!</p>
                                <p className="f-18 white-text mobile-center">Meet face-to-face with Eric Thomas, ET, The Hip Hop Preacher is bringing his motivation to Newark, NJ for the TAKE OWNERSHIP mastermind experience.</p>
                                <br/>
                                <p className="f-18 white-text mobile-center"><span className="f-26 bold-text">TAKE OWNERSHIP</span> is the end of the year mastermind event for people looking to make one new connection, learn one new strategy, and get leverage on themselves to exponentially grow their business.</p>
                                <div className="col s12 center-align mobile-center p0">
                                    <br/>
                                    <CTA/>
                                    <br/>
                                </div>
                                {/*MOBILE VERSION*/}
                                <div className="col s12 m10 offset-m1">
                                    <img className="img-sticky responsive-img relative-text" src="../static/Mastermind-ET-3.png"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default ETSection2;


// WEBPACK FOOTER //
// ./src/components/et-section2.js